if (!customElements.get('towa-knife-finder')) {
  let finderNumber = 0;
  customElements.define('towa-knife-finder', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.trigger = this.querySelector('.towa-knife-finder__trigger');
      this.desktop = this.querySelector('.towa-knife-finder__desktop');
      this.tabs = [...this.querySelectorAll('[data-towa-menu-tab]')];
      this.panels = [...this.querySelectorAll('[data-towa-menu-panel]')];
      const id = 'TowaFinder-' + (++finderNumber);
      this.desktop.id = id;
      this.trigger.setAttribute('aria-controls', id);
      this.tabs.forEach((tab, index) => {
        tab.id = id + '-tab-' + index;
        this.panels[index].id = id + '-panel-' + index;
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        ['pointerenter', 'focus', 'click'].forEach(event => tab.addEventListener(event, () => this.showPanel(index), options));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowUp') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.tabs[next].focus(); }
        }, options);
      });
      this.trigger.addEventListener('click', event => this.setOpen(event.detail > 0 || !this.classList.contains('is-open')), options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.setOpen(true); }, options);
      this.addEventListener('pointerleave', () => { if (!this.contains(document.activeElement)) this.setOpen(false); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.setOpen(false); }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          event.preventDefault(); event.stopPropagation(); this.setOpen(false); this.trigger.focus();
        }
        if (event.target === this.trigger && event.key === 'ArrowDown') {
          event.preventDefault(); this.setOpen(true); this.tabs[0].focus();
        }
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.setOpen(false); }, options);
      window.addEventListener('resize', () => { if (this.classList.contains('is-open')) this.positionPanel(); }, options);
      this.setOpen(false);
      this.showPanel(0);
    }
    disconnectedCallback() { this.events?.abort(); }
    showPanel(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
    setOpen(open) {
      this.classList.toggle('is-open', open);
      this.trigger.setAttribute('aria-expanded', String(open));
      this.desktop.inert = !open;
      if (open) this.positionPanel();
    }
    positionPanel() {
      this.desktop.style.left = '0px';
      const rect = this.desktop.getBoundingClientRect();
      const offset = Math.min(0, window.innerWidth - 16 - rect.right);
      this.desktop.style.left = Math.max(16 - rect.left, offset) + 'px';
    }
  });
}
